<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
    <form (ngSubmit)="save()" *ngIf="project && logicalConfig" class="dialog-form dialog-max-height-xxl" name="editForm">
        <div class="siklu-mat-dialog-title" matDialogTitle>
            <h4>{{ 'project.home.createOrEditLabel' | translate }}</h4>
            <button matDialogClose windeClose>
                <sui-svg-icon icon="cross"/>
            </button>
        </div>
        <div class="siklu-mat-dialog-body" matDialogContent>
            <winde-alert-error></winde-alert-error>

            <div *ngIf="viewInReadOnly" class="alert alert-warning">
                <span>{{ 'error.deleteLockedProject' | translate }}</span>
            </div>
            <div *ngIf="potentiallyCorruptedProject" class="alert alert-warning">
                <span>{{ 'error.validation.projectIsPotentiallyCorrupted' | translate }}</span>
            </div>

            <div
                    *ngIf="currentTab === productsRadioTabs.PRODUCT_CONFIG && !viewInReadOnly && !potentiallyCorruptedProject"
                    class="alert alert-warning"
            >
                <span>
                    {{ 'error.validation.productsValidationRule' | translate }}
                </span>
            </div>

            <winde-tabs-nav
                    (tabChanged)="changeTab($event)"
                    [activeTab]="currentTab"
                    [customClass]="'tabs-nav--doc-tabs mb-2 project-dialog-tabs'"
                    [tabsList]="tabsToShow"
                    [translationPrefix]="'project.projectConfigTabs'"
            >
            </winde-tabs-nav>

            <div [ngSwitch]="currentTab">
                <winde-project-dialog-general-tab
                        *ngSwitchCase="productsRadioTabs.GENERAL"
                        [logicalConfig]="logicalConfig"
                        [project]="project"
                        [viewInReadOnly]="viewInReadOnly || potentiallyCorruptedProject"
                ></winde-project-dialog-general-tab>

                <winde-project-dialog-product-config-tab
                        *ngSwitchCase="productsRadioTabs.PRODUCT_CONFIG"
                        [logicalConfig]="logicalConfig"
                        [project]="project"
                        [viewInReadOnly]="viewInReadOnly || potentiallyCorruptedProject"
                ></winde-project-dialog-product-config-tab>

                <winde-project-dialog-nw-config-tab
                        *ngSwitchCase="productsRadioTabs.NW_CONFIG"
                        [logicalConfig]="logicalConfig"
                        [viewInReadOnly]="viewInReadOnly || potentiallyCorruptedProject"
                ></winde-project-dialog-nw-config-tab>
            </div>
        </div>
        <div class="siklu-mat-dialog-footer justify-content-between flex-row-reverse" matDialogActions>
            <div>
                <button matDialogClose windeTransparent>
                    <sui-svg-icon icon="cross"/>
                    {{ 'entity.action.cancel' | translate }}
                </button>
                <button [disabled]="viewInReadOnly || potentiallyCorruptedProject" type="submit" windeGreen>
                    <sui-svg-icon icon="save"/>
                    {{ (project.id || project.id === 0 ? 'entity.action.save' : 'entity.action.create') | translate }}
                </button>
            </div>
            @if (!project.id) {
                <sui-checkbox-component [(isChecked)]="shouldOpenProject" label="project.openAfter.create"></sui-checkbox-component>
            }
        </div>
    </form>
</div>
